module.exports = __webpack_public_path__ + "static/img/dealercardwebH.069de8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/dealercardwebH.png
// module id = t/ly
// module chunks = 83